export const formatSecureFileLinkLine = (file) => `${file.fileName}: ${file.shareUrl}`;

export const formatSecureFileLinks = (files) => {
  if (!files.length) {
    return "";
  }

  return files.map(formatSecureFileLinkLine).join("\n");
};

export const insertTextAtSelection = ({ text, value, selectionStart, selectionEnd }) => {
  const start = typeof selectionStart === "number" ? selectionStart : value.length;
  const end = typeof selectionEnd === "number" ? selectionEnd : value.length;
  const nextValue = `${value.slice(0, start)}${text}${value.slice(end)}`;
  const nextSelection = start + text.length;

  return { nextValue, nextSelection };
};
